import React from "react";
import PropTypes from "prop-types";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";

import { lightTheme } from "theme/light";

import AuthProvider from "providers/AuthProvider";
import DialogProvider from "providers/DialogProvider";
import SnackbarWithCloseProvider from "providers/SnackbarWithCloseProvider";
import SearchProvider from "providers/SearchProvider";

function AppProviders({ children }) {
  return (
    <ThemeProvider theme={lightTheme}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <SnackbarWithCloseProvider>
          <AuthProvider>
            <DialogProvider>
              <SearchProvider>
                <StyledEngineProvider injectFirst>
                  {children}
                </StyledEngineProvider>
              </SearchProvider>
            </DialogProvider>
          </AuthProvider>
        </SnackbarWithCloseProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

AppProviders.propTypes = {
  children: PropTypes.any.isRequired,
};

export default AppProviders;
